import clsx from 'clsx';
import type { CSSProperties, FC } from 'react';
import { Link } from 'react-router-dom';

export type BreadcrumbItem = {
  label: string;
  to?: string;
};

export interface BreadcrumbTrailProps {
  items: readonly BreadcrumbItem[];
  ariaLabel?: string;
  className?: string;
}

const breadcrumbTextStyle: CSSProperties = {
  fontFamily: 'Basis Grotesque',
};

const BreadcrumbTrail: FC<BreadcrumbTrailProps> = ({
  items,
  ariaLabel = 'Breadcrumb',
  className,
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <nav aria-label={ariaLabel} className={clsx('mb-2 flex items-center', className)}>
      <div className="flex flex-wrap items-center gap-0.5 text-[10px] leading-[1.43] tracking-[0.17px] text-[#262626]">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const key = `${item.label}:${item.to ?? index}`;
          return (
            <span className="inline-flex items-center" key={key}>
              {!isLast && item.to ? (
                <Link
                  className="font-medium text-[#262626] underline decoration-solid underline-offset-2"
                  style={breadcrumbTextStyle}
                  to={item.to}
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'font-bold' : 'font-medium'} style={breadcrumbTextStyle}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span aria-hidden="true" className="px-1 font-medium" style={breadcrumbTextStyle}>
                  /
                </span>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default BreadcrumbTrail;
